export default __webpack_public_path__ + "static/media/icon_austcham.50ddb54a.webp";